import JobLinkLayouts from './JobLinkLayout';

export default JobLinkLayouts;
